module.exports = __webpack_public_path__ + "static/img/ligo_09.29daf5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/ligo_09.png
// module id = /33W
// module chunks = 0